import { AtlasMapValue, CachedImageData } from 'game-ui-types'

export interface AtlasImageStyles {
    backgroundImage: string
    backgroundPosition: string
    width: string
    height: string
    backgroundRepeat: string
    backgroundSize?: string
    transform?: string
}

export const buildAtlasImageStyles = (
    atlasName: string,
    image: AtlasMapValue,
    cachedImage?: CachedImageData,
    scale = 1
): AtlasImageStyles | undefined => {
    if (!image) {
        return
    }

    let conditionalStyle = {}

    if (scale !== 1 && cachedImage) {
        conditionalStyle = { backgroundSize: `${cachedImage.width * scale}px ${cachedImage.height * scale}px` }
    }

    if (image.rotate) {
        conditionalStyle = { ...conditionalStyle, transform: `rotate(${[0, 90, -90, 180][image.rotate]}deg)` }
    }

    return {
        backgroundImage: `url(${cachedImage?.url ?? atlasName})`,
        backgroundPosition: `-${image.x * scale}px -${image.y * scale}px`,
        width: `${image.width * scale}px`,
        height: `${image.height * scale}px`,
        backgroundRepeat: 'no-repeat',
        ...conditionalStyle,
    }
}
